export default {
  beforeTradeIn: {
    id: 'product_price_wrapper_trade_in',
    defaultMessage: 'before trade-in',
  },
  originalPriceDisplay: {
    id: 'product_page_add_to_cart_original_price_display',
    defaultMessage: '{price} new',
  },
  strikedPriceExplanation: {
    id: 'stroked_price_explanation',
    defaultMessage:
      "Crossed out prices may be the manufacturer's suggested retail price, or may be calculated from the average price of the product from different retail distributors.",
  },
  productVatIncluded: {
    id: 'product_vat_included',
    defaultMessage: 'VAT inclusive*',
  },
}
